@if (opened) {
  <div class="container" [@alertAnimation]>
    <div>
      <div class="title text-xl">{{ title | translate }}</div>
      <div class="description">{{ description | translate }}</div>
    </div>
    <div class="buttons-container">
      <div class="cta-wrapper">
        @if (cta) {
          <rk-button [text]="cta" [variant]="variant" class="cta-button"></rk-button>
        }
      </div>
      @if (close) {
        <rk-button
          [variant]="'white'"
          [iconOnly]="true"
          (buttonClick)="closeAlert()"
          [icon]="'close'"
          [colorVariant]="variant"
        ></rk-button>
      }
    </div>
  </div>
}
